import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

const Home = lazy(() => import("../Pages/Home"));
const About = lazy(() => import("../Pages/About"));
const Services = lazy(() => import("../Pages/Services"));
const Careers = lazy(() => import("../Pages/Careers"));
const CareersDetail = lazy(() => import("../Pages/CareersDetail"));
const News = lazy(() => import("../Pages/News"));
const NewsDetail = lazy(() => import("../Pages/NewsDetail"));
const Contact = lazy(() => import("../Pages/Contact"));

const MainRoutes = () => {
  return (
    <Suspense>
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/about/:section?" element={<About />} />
        <Route path="/services/:service?" element={<Services />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/careers/:id" element={<CareersDetail />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:id" element={<NewsDetail />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Suspense>
  );
};

export default MainRoutes;
